import { LayoutComponents } from '@shared/models';

export const LAYOUT_TYPES = {
  KPIdashboard: 'KPI_dashboard',
  customDashboard: 'custom_dashboard',
  powerBiDashboard: 'powerbi_dashboard',
};

export const DASHBOARD_CONTAINER_LAYOUT_TYPES = [
  LAYOUT_TYPES.customDashboard,
  LAYOUT_TYPES.powerBiDashboard,
];

export const COMPONENT_TYPES = {
  powerbi: 'powerbi',
  customChart: 'customChart',
  kpiCard: 'kpiCard',
};

export const COMPONENT_OPTIONS: LayoutComponents[] = [
  {
    name: 'Custom Chart',
    value: COMPONENT_TYPES.customChart,
  },
  {
    name: 'Power BI',
    value: COMPONENT_TYPES.powerbi,
  },
];

export const GET_COMPONENT = (type: string) =>
  COMPONENT_OPTIONS.find(component => component.value === type);

export const isDashboardContainerLayoutType = (layoutType?: string): boolean =>
  !!layoutType && DASHBOARD_CONTAINER_LAYOUT_TYPES.includes(layoutType);
